import React, { RefObject, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
type FloatingCTAProps = {
  triggerRef: RefObject<HTMLAnchorElement>;
};
export function FloatingCTA({
  triggerRef
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = triggerRef.current;
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [triggerRef]);
  return <AnimatePresence data-id="element-132" data-mp="38d1w7sxe5izl">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-2" data-id="element-133" data-mp="33jqlhgpgki2e">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl bg-cta px-5 py-4 text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_6px_0_0_#0F6B32,0_12px_30px_rgba(0,0,0,0.25)] transition-colors duration-150 ease-out hover:bg-cta-dark focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-base" data-id="element-134" data-mp="2pbczjpkwwh6i">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-135" data-mp="2bc3hslh25f0f" />
            Get instant access — $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}